var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',{staticClass:"home-footer"},[_c('div',{staticClass:"home-inner"},[_c('p',[_vm._v("主办单位：中共重庆市委宣传部、重庆市教育委员会")]),_c('p',[_vm._v("承办单位：重庆大学新闻学院、重庆大学融媒体中心")]),_c('p',[_vm._v("\n      协办单位：西南大学、西南政法大学、重庆师范大学、重庆工商大学、四川外国语大学\n    ")])])])
}]

export { render, staticRenderFns }